import { render, staticRenderFns } from "./recordBank.vue?vue&type=template&id=49c9791b&scoped=true"
import script from "./recordBank.vue?vue&type=script&lang=js"
export * from "./recordBank.vue?vue&type=script&lang=js"
import style0 from "./recordBank.vue?vue&type=style&index=0&id=49c9791b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c9791b",
  null
  
)

export default component.exports